import { API } from '@aws-amplify/api'
import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'
import {
  addTrfInfo,
  setSlideDiagnosisOptions,
  setImageQualityOptions,
  getCaseData,
  selectImageForReport,
  setShowingRect,
  addSampleLocationData,
  addSummaryTreeData,
  addBarcodeData,
  setAllSlides,
  addClinicalInfo,
  saveSlideDiagnosisData,
  getSlideDiagnosisData,
  getReportHistoryData,
  setPatientHistory,
  saveReportDataResponse,
  saveAmendResponse,
  getCPTCodesData,
  updateConsultResponse,
  updateConsultCompleteResponse,
  addPathologistsList,
  getPathologistsListResponse,
  refreshCase,
  refreshResponse,
  updateRefreshInProgress,
  auditClassifier,
} from '../actions'

export const clearPremerisApiCache = () => async (dispatch) => {
  await dispatch(addTrfInfo({ payload: {} }))
  await dispatch(addSampleLocationData({ payload: {} }))
  await dispatch(addClinicalInfo({ payload: {} }))
  await dispatch(setPatientHistory({ payload: {} }))
  await dispatch(getCPTCodesData({ payload: {} }))
  await dispatch(getSlideDiagnosisData({ payload: {} }))
  await dispatch(getReportHistoryData({ payload: {} }))
}

export const getTrfInfo =
  ({ trfBarcode }) =>
  async (dispatch) => {
    const apiName = '/premeris/slideBarcodeInfo/getTrfInfo'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}`, options)
      if (result) {
        await dispatch(addTrfInfo({ payload: result }))
        return result
      }
    } catch (err) {
      console.log('getTrfInfo Error', err)
    }
  }

export const refreshCaseData =
  ({ trfBarcode }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/premeris/reportinfo/refreshorderinfo'
    try {
      const options = {
        headers: {},
        response: false,
      }

      dispatch(updateRefreshInProgress({ inProgress: true }))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}`, options)
      action = 'REFRESH_CASE_SUCCESS'

      if (result) {
        await dispatch(refreshCase({ payload: result }))
        return result
      }
    } catch (err) {
      action = 'REFRESH_CASE_ERROR'
      console.log('refreshCaseData Error', err)
    } finally {
      dispatch(refreshResponse({ action: action }))
      dispatch(updateRefreshInProgress({ inProgress: false }))
    }
  }

export const getSlideDiagnosisOptions =
  ({ procedureCode }) =>
  async (dispatch) => {
    const apiName = '/case-management/slideDiagnosisOptions'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${procedureCode}`, options)
      if (result && result.slideDiagnosisOptions.length > 0) {
        await dispatch(setImageQualityOptions({ payload: result.imageQualityOptions }))
        await dispatch(
          setSlideDiagnosisOptions({ payload: JSON.parse(result.slideDiagnosisOptions[0].diagnosisOptionJson) }),
        )
      }
    } catch (err) {
      console.log('getSlideDiagnosisOptions Error', err)
    }
  }

export const setCaseData =
  ({
    pathologist,
    pathologistId,
    patientName,
    caseNumber,
    workflowId,
    procedureCodeId,
    caseId,
    nlOrderId,
    statFlag,
    userCaseWorkflowId,
    slideStatusId,
    mcFlag,
  }) =>
  async (dispatch) => {
    await dispatch(
      getCaseData({
        payload: {
          pathologist: pathologist,
          pathologistId: pathologistId,
          patientName: patientName,
          caseNumber: caseNumber,
          workflowId: workflowId,
          procedureCodeId: procedureCodeId,
          caseId: caseId,
          nlOrderId: nlOrderId,
          statFlag: statFlag,
          userCaseWorkflowId: userCaseWorkflowId,
          slideStatusId: slideStatusId,
          mcFlag: mcFlag,
        },
      }),
    )
  }

export const imageSelectionForReport =
  ({ trfBarcode, slideBarcode, image }) =>
  async (dispatch) => {
    await dispatch(
      selectImageForReport({ payload: { trfBarcode: trfBarcode, slideBarcode: slideBarcode, image: image } }),
    )
  }

export const setShowingRectangle = (regOrBlue, clid) => async (dispatch) => {
  await dispatch(setShowingRect({ whichRectSet: 'reg', clid: clid }))
}

export const setAllSlidesData =
  ({ previousTrfBarcode, allSlides }) =>
  async (dispatch) => {
    await dispatch(setAllSlides({ payload: { previousTrfBarcode: previousTrfBarcode, allSlides: allSlides } }))
  }

export const getSampleLocationData =
  ({ trfBarcode, procedureCode }) =>
  async (dispatch) => {
    const apiName = '/premeris/slideBarcodeInfo/getSampleTreeData'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(
        WOMA_API_GATEWAY_NAME,
        `${apiName}/${trfBarcode}/procedure/${procedureCode}`,
        options,
      )
      if (result) {
        await dispatch(addSampleLocationData({ payload: result }))
      }
    } catch (err) {
      console.log('getSampleLocationData Error', err)
    }
  }

export const getSummaryTreeData =
  ({ trfBarcode, location, procedureCode }) =>
  async (dispatch) => {
    const apiName = '/premeris/reportInfo/sampleSummary'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(
        WOMA_API_GATEWAY_NAME,
        `${apiName}/${trfBarcode}/${location}/${procedureCode}`,
        options,
      )
      if (result) {
        await dispatch(addSummaryTreeData({ payload: result }))
      }
    } catch (err) {
      console.log('getSummaryTreeData Error', err)
    }
  }

export const getBarcodeData =
  ({ trfBarcode, slide, multiple_classifiers_allowed }) =>
  async (dispatch) => {
    const apiName = '/premeris/slideBarcodeInfo/main'
    let location = ''
    if (slide || slide !== '') {
      location = '/' + slide + '/' + multiple_classifiers_allowed
    }
    try {
      const options = {
        headers: {},
        response: true,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}${location}`, options)
      if (result) {
        await dispatch(addBarcodeData(result, null))
      }
    } catch (err: any) {
      await dispatch(addBarcodeData({}, err.response.data))
    }
  }

export const saveSlideDiagnosis =
  ({ currentSlideBarcode, data }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/premeris/slideBarcodeInfo/saveSlideDiagnosis'
    try {
      const options = {
        headers: {},
        response: false,
        body: data,
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}/${currentSlideBarcode}`, options)
      if (result) {
        action = 'SAVE_SLIDE_DIAGNOSIS_SUCCESS'
      }
    } catch (err) {
      action = 'SAVE_SLIDE_DIAGNOSIS_ERROR'
      console.log('saveSlideDiagnosis Error', err)
    } finally {
      await dispatch(saveSlideDiagnosisData({ action: action }))
    }
  }

export const getSlideDiagnosis =
  ({ trfBarcode }) =>
  async (dispatch) => {
    const apiName = '/premeris/slideBarcodeInfo/getSlideDiagnosisData'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}`, options)
      if (result) {
        await dispatch(getSlideDiagnosisData({ payload: result }))
      }
    } catch (err) {
      console.log('getSlideDiagnosis Error', err)
    }
  }

export const getReportHistory =
  ({ trfBarcode }) =>
  async (dispatch) => {
    const apiName = '/premeris/slideBarcodeInfo/getReportHistory'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}`, options)
      if (result) {
        await dispatch(getReportHistoryData({ payload: result }))
      }
    } catch (err) {
      console.log('getReportHistory Error', err)
    }
  }

export const getClinicalInfo =
  ({ trfBarcode }) =>
  async (dispatch) => {
    const apiName = '/premeris/reportInfo/getClinicalInfo'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}`, options)
      if (result) {
        dispatch(addClinicalInfo({ payload: result }))
      }
    } catch (err) {
      console.log('getClincialInfo Error', err)
    }
  }

export const getPatientHistory =
  ({ trfBarcode }) =>
  async (dispatch) => {
    const apiName = '/premeris/reportInfo/patientHistory'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}`, options)
      if (result) {
        dispatch(setPatientHistory({ payload: result }))
      }
    } catch (err) {
      console.log('getPatientHistory Error', err)
    }
  }

export const getCPTCodes =
  ({ trfBarcode }) =>
  async (dispatch) => {
    const apiName = '/premeris/reportInfo/getTCPC'
    try {
      const options = {
        headers: {},
        response: false,
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${trfBarcode}`, options)
      if (result) {
        dispatch(getCPTCodesData({ payload: result }))
      }
    } catch (err) {
      console.log('getCPTCodes Error', err)
    }
  }

export const saveReportData =
  ({ trfBarcode, cptCodes, saveDraftJSON, reason, diagnosisLP, consultLP, calloutDecision, procedureCode }) =>
  async (dispatch) => {
    let action = ''

    const apiName = '/premeris/slideBarcodeInfo/saveReportData'

    try {
      if (trfBarcode) {
        const data = {
          trfBarcode: trfBarcode,
          saveDraftJSON: saveDraftJSON,
          cptCodes: cptCodes,
          reason: reason,
          consultLP: consultLP,
          diagnosisLP: diagnosisLP,
          callout: calloutDecision,
          procedureCode: procedureCode,
        }
        const options = {
          headers: {},
          response: false,
          body: data,
        }
        const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
        if (result) {
          action = 'SAVE_REPORT_SUCCESS'
        }
      } else {
        action = 'SAVE_REPORT_RESET'
      }
    } catch (err) {
      console.log('saveReportData Error', err)
      action = 'SAVE_REPORT_ERROR'
    } finally {
      await dispatch(saveReportDataResponse({ action: action }))
    }
  }

export const amendReportUpload =
  ({ userId, pathologistId, userCaseWorkflowId, caseId, caseNumber, nlOrderId, slideStatusId, statFlag, mcFlag }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/case-management/amendReportUpload'
    try {
      if (caseNumber !== '') {
        const data = {
          userCaseWorkflowId: userCaseWorkflowId,
          caseId: caseId,
          caseNumber: caseNumber,
          nlOrderId: nlOrderId,
          slideStatusId: slideStatusId,
          statFlag: statFlag,
          mcFlag: mcFlag,
          userId: userId,
          pathologistId: pathologistId,
        }
        const options = {
          headers: {},
          response: true,
          body: data,
        }
        const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
        if (result) {
          action = 'AMEND_REPORT_SUCCESS'
        }
      }
    } catch (err: any) {
      console.log('message', JSON.parse(err.response.data).message)
      action = 'AMEND_REPORT_ERROR'
    } finally {
      await dispatch(saveAmendResponse({ action: action }))
    }
  }

export const consultCase =
  ({ userId, caseId }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/case-management/pathologist/consult'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          caseid: caseId,
          consultstatus: 'CONSULT',
        },
      }
      const result = await API.put(WOMA_API_GATEWAY_NAME, `${apiName}/${userId}?`, options)
      action = 'CONSULT_CASE_SUCCESS'
    } catch (err) {
      action = 'CONSULT_CASE_ERROR'
      console.log('consultCase Error', err)
    } finally {
      dispatch(updateConsultResponse({ action: action }))
    }
  }

export const getPathologistsList =
  ({ id, caseId }) =>
  async (dispatch) => {
    // const apiName = '/case-management/pathologist/consult-list'
    const apiName = 'user-management/users'
    try {
      const options = {
        headers: {},
        response: false,
        /* queryStringParameters: {
                                  caseid: caseId,
                                  caseuserid: id,
                                }, */
      }
      // const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}?`, options)
      const result = await API.get(WOMA_API_GATEWAY_NAME, `/${apiName}`, options)
      if (result?.data) {
        if (result.data.length === 0) {
          dispatch(getPathologistsListResponse({ action: 'EMPTY_PATHOLOGISTS_LIST' }))
        } else {
          dispatch(addPathologistsList({ payload: result }))
          dispatch(getPathologistsListResponse({ action: 'ADD_PATHOLOGISTS_LIST' }))
        }
      }
    } catch (err) {
      console.log('getPathologistsList Error', err)
    }
  }

export const auditClassifierAccessed =
  ({ userId, case_number, location, stain, img_version, img_url, img_type, success }) =>
  async (dispatch) => {
    //let action=''
    const apiName = '/case-management/pathologist/auditClassifierAccessed'
    try {
      const data = {
        user_ad_id: userId,
        case_number: case_number,
        location: location,
        stain: stain,
        img_version: img_version,
        img_url: img_url,
        img_type: img_type,
        success: success,
      }
      const options = {
        headers: {},
        response: true,
        body: data,
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}`, options)
      dispatch(auditClassifier({ payload: result }))
    } catch (err: any) {
      console.log('message', JSON.parse(err.response.data).message)
    }
  }

export const consultComplete =
  ({ userId, caseId }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/case-management/pathologist/consult'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          caseid: caseId,
          consultstatus: 'CONSULT_COMPLETED',
        },
      }
      const result = await API.put(WOMA_API_GATEWAY_NAME, `${apiName}/${userId}?`, options)
      action = 'CONSULT_COMPLETE_SUCCESS'
    } catch (err) {
      action = 'CONSULT_COMPLETE_ERROR'
      console.log('consultComplete Error', err)
    } finally {
      dispatch(updateConsultCompleteResponse({ action: action }))
    }
  }
